module.exports = __webpack_public_path__ + "img/img-banner.b43c59bb.png";